/* global BISPopover */

// Variant updates to change visibility of Back In Stock button
class BISToggle {
  constructor() {
    this.BISVariant();
  }

  BISVariant() {
    if (!window.theme.template === 'product') {
      return;
    }

    const addToCartButtonElement = document.getElementsByClassName('product-form__add-button')[0];
    const paymentContainer = document.getElementsByClassName('product-form__payment-container')[0];

    document.addEventListener('variant:changed', (event) => {
      const variant = event.detail.variant;

      if (!variant || variant.available) {
        if (document.getElementById('BIS_trigger')) {
          document.getElementById('BIS_trigger').remove();
        }
      } else if (variant) {
        const variantId = variant.id;
        if (!document.getElementById('BIS_trigger')) {
          const BISButton = document.createElement('button');
          const BISButtonElement = BISButton;

          BISButtonElement.classList.add('button', 'button--primary', 'bis--button');
          BISButtonElement.id = 'BIS_trigger';
          BISButtonElement.innerHTML = 'Notify Me';
          BISButtonElement.remove();
          paymentContainer.insertBefore(BISButtonElement, addToCartButtonElement.nextSibling);
          BISButtonElement.addEventListener('click', () => {
            BISPopover.form.selectVariant(variantId);
          });
        }
      }
    });
  }
}

export default BISToggle;
